import React, { useEffect, useState } from "react";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import { Divider } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { List, Box } from "@material-ui/core";
import InputBase from "@material-ui/core/InputBase";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import {
  updateMileage,
  updatePricingHistory,
  getInspectionVehicleDetails,
  getReasonsForUngrounding,
  getUngroundingDetailByVIN,
  submitUngroundingRequest,

} from "../service/api";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import Alert from "@material-ui/lab/Alert";
import CheckIcon from "@material-ui/icons/Check";
import ViewFullPricingHistory from "./ViewFullPricingHistory";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import NumberFormat from 'react-number-format';

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: "#ffffff",
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    height: "10px",
    padding: "10px 12px",
    "&:focus": {
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

export default function SubmitUnground(props) {
  const vin = props?.vin;
  const [noteval, setNoteVal] = useState("");
  const [updateStatus, setUpdateStatus] = useState(null);
  const [isLoading, setIsloading] = useState(false)
  const [updateMileageReason, setUpdateMileageReason] = useState([]);
  const [userUpdateMileageReason, setUserUpdateMileageReason] = useState('');
  const [hideCheckBox, setHideCheckBox] = useState(false);
  const [otherReasonError, setOtherReasonError] = useState(false);
  const [submitButtonValue, setSubmitButtonValue] = useState(true);
  const [isOtherReason, setOtherReason] = useState(false);
  const [warningMesssage, setWarningMesssage] = useState('')
  const [warningMesssageSeverity, setwarningMesssageSeverity] = useState('error')
  const [isUngrounded,setIsUngrounded] = useState(false);


  useEffect(() => {
    getUpdateMileageReason();
    getStatusByVin();
  }, [vin]);

  const initialMileageForm = {
    groundingMileage: null,
    confirmGroundingMileage: null,
    reasonForUpdate: null,
    hasErr: false,
  };
  const [mileageForm, setMileageForm] = useState(initialMileageForm);
  const initialVehiclePriceForm = {
    vehicle_price: null,
    confirm_vehicle_price: null,
    MMR: null,
    hasErr: false,
    isMMRRequired: false,
  }
  const [vehiclePriceForm, setVehiclePriceForm] = useState(initialVehiclePriceForm);

  const handleUpdateReason = (event) => {
    setUserUpdateMileageReason(event?.target?.value ? event.target.value : '');
    setNoteVal('');
    if (event?.target?.value === 'Other' || event?.target?.value === 'Grounded in Error') {
      setOtherReasonError(true);
      setSubmitButtonValue(true);
      setOtherReason(true)
      mileageForm.otherReason = '';
      setMileageForm({
        ...mileageForm,
        ...{ [event.target.name]: event.target.value },
      });
    } else {
      delete mileageForm.otherReason;
      setSubmitButtonValue(false);
      setOtherReasonError(false);
      setOtherReason(false)
      setMileageForm({
        ...mileageForm,
        ...{ [event.target.name]: event.target.value },
      });
    }
  }

  async function getUpdateMileageReason() {
    let apiResponse = await getReasonsForUngrounding();
    setIsloading(true)
    if (apiResponse && apiResponse?.data) {
      console.log(apiResponse);
      setUpdateMileageReason(apiResponse?.data);
    }
  }

  async function getStatusByVin() {
    const statusRequest = {
      vin: vin
    }
    const validStatuses = ['DRAFT', 'READY', 'AVAILABLE', 'CLAIMED', 'UNCLAIMED', 'ASSIGNED', 'REJECTED'];
    let message = '';
    let apiResponse = await getUngroundingDetailByVIN(statusRequest);
    setIsloading(true)
    if (apiResponse && apiResponse?.data) {
      if (apiResponse.data?.ungrounded) {
        setIsUngrounded(true);
        message = ' Vehicle is Already Ungrounded.\n Ungrounding Request cannot be submitted.';
      } else if(apiResponse.data?.transported || apiResponse.data?.sold || apiResponse.data?.auction ) {
        if (apiResponse.data?.transported && apiResponse.data?.transportationStatus) {
        let canTransportMessage = validStatuses.includes(apiResponse.data.transportationStatus?.toUpperCase()) ? '\nSystem will place a request to cancel the transportation request.' : 'System cannot cancel the transportation request.';
        message = 'Vehicle Transportation Status - ' + apiResponse.data.transportationStatus + '.\n' + canTransportMessage;
      } if (apiResponse.data?.sold) {
        message += '\nVehicle is Already sold. System will create an Arbitration Request';
      } if (apiResponse.data?.auction) {
        message += '\nVehicle is in Auction (Preview/Buy/Bid)';
      }
      message += '\n\nDo you still want to unground?';
    }
    setWarningMesssage(message);
    }
  }

  async function submitUngroundResponse() {
    const groudingObject = {
      UngroundingNotes: noteval,
      UngroundingReason: userUpdateMileageReason,
      VIN: vin
    }
    let apiResponse = await submitUngroundingRequest(groudingObject);
    setIsloading(true)
    if (apiResponse && apiResponse?.status === 200 && apiResponse?.data) {
      setIsUngrounded(true);
      setWarningMesssage('Ungrounding request  has been submitted successfully.');
      setwarningMesssageSeverity('success');
    }
    else {
      setWarningMesssage('Uh Oh! We encountered an error when submitting the request to unground.')
      setwarningMesssageSeverity('error');

    }
  }

  const updateCheckBox = (value) => {
    setHideCheckBox(value)
  }

  let mileageFormError = false;
  let vehiclePriceFormError = false;
  Object.keys(mileageForm).forEach(item => {
    if (mileageForm[item] === null || mileageForm[item] === '') {
      mileageFormError = true;
    }
  })
  Object.keys(vehiclePriceForm).forEach(item => {
    if (vehiclePriceForm[item] === null || vehiclePriceForm[item] === '' || vehiclePriceForm.vehicle_price !== vehiclePriceForm.confirm_vehicle_price) {
      vehiclePriceFormError = true;
    }
  })

  const onTextFieldChange = (e) => {
    setNoteVal(e.target.value)

    if (e.target.value && isOtherReason) {
      setOtherReasonError(false)
      setSubmitButtonValue(false)
    } else if (!e.target.value && isOtherReason) {
      setOtherReasonError(true)
      setSubmitButtonValue(true)
    }

  }

  return (
    <div className={isLoading ? "updateUngroundingSidebar" : ""}>
      <div className="notesSectionHeader">
        <h3>Ungrounding</h3>
      </div>

      {
        <div>
          {warningMesssage && <div style={{ margin: "20px 5px 15px 15px" }}>
            <Alert variant="outlined" severity={warningMesssageSeverity}>
              {warningMesssage.split("\n").map((line, index) => (
                <span key={index}>
                  {line}
                  <br />
                </span>
              ))}
            </Alert>
          </div>
          }

          <div className="ungroundReason">
            <InputLabel >Reason</InputLabel>
            <FormControl variant="outlined">
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                value={userUpdateMileageReason}
                name="reasonForUnground"
                onChange={handleUpdateReason}
                onOpen={() => updateCheckBox(false)}
                onClose={() => updateCheckBox(true)}
                position='bottom'
                disabled={isUngrounded}
                style={{
                  backgroundColor: isUngrounded ? "#e0e0e0" : "#ffffff",
                  color: isUngrounded ? "#a0a0a0" : "#000000",
                  cursor: isUngrounded ? "not-allowed" : "pointer",
                }}
              >
                {updateMileageReason.map((reason) => (
                  <MenuItem key={reason} value={reason}>
                    <div className={userUpdateMileageReason && userUpdateMileageReason?.indexOf(reason) > -1 ? 'selectedReason' : 'unselectedReason'}>
                      {!hideCheckBox && userUpdateMileageReason && userUpdateMileageReason?.indexOf(reason) > -1 && <CheckIcon style={{ color: 'red' }} />}
                    </div>
                    <ListItemText className="reasonText" primary={reason} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
      }

      <Box>
        <ListItem>
          <InputLabel style={{ marginTop: '20px', marginBottom: '20px' }}>Admin Notes</InputLabel>
        </ListItem>
        <ListItem>
          <TextField
            className="ungroundNotesText notesTextContent"
            value={noteval}
            rows={10}
            width='50px'
            multiline
            label="Notes..."
            variant="outlined"
            onChange={onTextFieldChange}
            inputProps={{ maxLength: 500 }}
            disabled = {isUngrounded}
            style={{
              backgroundColor: isUngrounded ? "#e0e0e0" : "#ffffff",
              color: isUngrounded ? "#a0a0a0" : "#000000",
              cursor: isUngrounded ? "not-allowed" : "text",
            }}
          />
          {noteval?.length === 500 && <span style={{ color: 'red', fontSize: '12px', paddingLeft: '1rem' }} >Maximum Character Limit Reached</span>}
          <div className="ungroundReasonCount">{noteval?.length}/500</div>
        </ListItem>
        <ListItem>
          {otherReasonError && <span style={{ color: 'red', fontSize: '12px', paddingLeft: '1rem', marginLeft: '50px' }} >Admin note is mandatory for selected ungrounding reason.</span>}
        </ListItem>
        <ListItem>
          <Button
            disabled={submitButtonValue}
            autoFocus
            variant="contained"
            onClick={submitUngroundResponse}
            style={{ marginLeft: "65px" }}
          >
            Submit
          </Button>
        </ListItem>
      </Box>

    </div>
  );
}
